// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root__2x45O","title":"About_title__1vhXy","logo":"About_logo__JeK-w","paper":"About_paper__1LSLu","content":"About_content__ga2RO"};